import { commonSlice } from '../slices/commonSlice';

export default commonSlice.reducer;
